import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  :root {
    --primary_cyan_color: #49baae;
    --second_yellow_color: #fed44a;

    --main_black_color: #0f0f0f;
    --main_white: #fff;
    --main_red_color: #f00;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* 'Roboto Medium' nunca foi carregada (nao esta no index.html) e sempre
       caiu no sans-serif do sistema. Raleway e a familia que o corpo do
       produto ja usa em ~60 ocorrencias e ja esta carregada. */
    font-family: 'Raleway', sans-serif;

    &::-webkit-scrollbar {
      display: none;
    }

    @media(max-width: 830px){
      body{
        /* min-width: 820px; */
      }
    }
    @media(max-height: 670px){
      body{
        min-height: 663px;
      }
    }
  }

  /* Foco de teclado: visível apenas para navegação por teclado (:focus-visible),
     não para clique de mouse. Cor = Âmbar de Foco, o mesmo token que já marca
     estado em campos de formulário (ver DESIGN.md). */
  *:focus:not(:focus-visible) {
    outline: none;
  }

  *:focus-visible {
    outline: 2px solid #ffa22b;
    outline-offset: 2px;
  }

  html {
    scroll-behavior: smooth;
  }

  /* Texto so para leitor de tela. Visualmente ausente, mas presente na arvore
     de acessibilidade — ao contrario de display: none e visibility: hidden,
     que removem o no, e de opacity: 0, que deixa o elemento ocupando espaco e
     na ordem de tabulacao. */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  /* Movimento reduzido. Deliberadamente NAO e um "animation: 0.01ms !important"
     global: isso mataria junto o spinner de carregamento e as transicoes de
     cor que comunicam estado (borda de campo em foco, hover de link), que sao
     feedback e nao decoracao.
     O que morre aqui e o que so enquadra: o shimmer em loop infinito, o scroll
     suave e os deslocamentos de entrada. A entrada do Login e tratada em JS
     via useReducedMotion, porque framer-motion escreve style inline. */
  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-iteration-count: 1 !important;
      transition-duration: 0.15s !important;
    }
  }

  body {
    background: #0f0f0f;

    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    overflow-x: hidden;
    /* margin-bottom: 2rem; */

    div#root {
      width: 100%;
      max-width: 100%;
      overflow: hidden;
    }
  }

  .block_scroll{
    display: block;
    overflow-y: hidden;
    overflow-x: hidden;
    overflow: hidden;
    margin: 0;
    height: 100%;
    overflow: hidden;
  }

  /* Carrousel temporary state */
  .lower{
    z-index: -9999 !important;
  }
  .normal{
    z-index: unset;
  }
  .upper{
    z-index: 999;
  }
  /**--------------------------------- */

  /** price */
  .price-span {
    color: rgb(254,212,74,1);
    font-family: 'Roboto', sans-serif;
    font-weight: bolder !important;
    font-size: 0.825rem;
    margin-bottom: auto;

    /* A classe se chama "green" mas pintava #000 — preto sobre o painel do
       carrinho, que era branco na epoca em que isso foi escrito. Com o painel
       agora no degrau tonal do sistema (#222222), preto media ~1.3:1: o preco
       do produto ficava praticamente invisivel.
       O override foi removido, entao vale o ouro do proprio .price-span, que e
       o que o DESIGN.md manda para preco. A classe segue no JSX do
       CartCourseCard (unico consumidor em todo o src) e agora e inerte. */
  }

  /**------------- */

  .header-warp{
    /* border: solid 1px red; */
  }

  .hasVerticalScroll{
    overflow-x: hidden !important;

    &::-webkit-scrollbar {
      display: unset;
    }
    &::-webkit-scrollbar {
      width: 4px !important;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #565f7c;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .hasHorizontalScroll{
    overflow-y: hidden !important;
    scrollbar-width: thin !important;

    &::-webkit-scrollbar {
      height: 8px !important;
      display: unset;
      /* max-width: 10px !important; */
    }
    &::-webkit-scrollbar-track {
      background: #ABB1C5;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #161a21;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #303236;
      width: 1px !important;
    }
  }
  .overlayed{
    overflow: hidden;
  }
`;
